module.exports = __webpack_public_path__ + "assets/img/neptun.5dff67f1.png";